module.exports = __webpack_public_path__ + "static/media/ic_close_white_24px.7b66831c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/ic_close_white_24px.svg
// module id = 790
// module chunks = 0